import React from 'react';
import ReactDOM from 'react-dom';
import App from '@/App';
import reportWebVitals from './reportWebVitals';

import './i18n.js'


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
